module.exports = __webpack_public_path__ + "static/media/minus.63de1b7b.svg";